import { queryOptions } from "@tanstack/react-query";

import { UnderlyingSymbol } from "#/types/markets";

import { type InstrumentsResponse } from "../kyan.types";

const fetchInstrumentsClient = async (
  market: string,
): Promise<InstrumentsResponse> => {
  const response = await fetch(
    `/api/instruments?market=${encodeURIComponent(market)}`,
  );

  if (!response.ok) {
    throw new Error("Failed to fetch instruments");
  }

  return response.json();
};

export const getInstrumentsQueryOptions = (underlying: UnderlyingSymbol) =>
  queryOptions({
    queryKey: ["fetchInstruments", underlying],
    queryFn: () => fetchInstrumentsClient(underlying),
    select: (response) => response.instruments,
  });
